'use client'

// components
import IconButton from '@/components/Button/IconButton';

// svgs
import CloseIcon from '@/public/svg/close.svg';

// styles
import styles from './ExploreHubTitleDescription.module.scss';

interface ExploreHubTitleDescriptionProps {
  titleText: string;
  descriptionText: string;
}

const POPOVER_ID = 'explore-hub-description-popover';

const ExploreHubTitleDescription = (props: ExploreHubTitleDescriptionProps) => {
  const { titleText, descriptionText } = props;

  return (
    <div className={styles.explore_hub_title_description}>
      <div className={styles.explore_hub_title_description__title_wrapper}>
        <h1>{titleText}</h1>
        <IconButton
          icon="information"
          title={`About ${titleText}`}
          className={styles.explore_hub_title_description__info_button}
          noOutline={false}
          popoverTarget={POPOVER_ID}
        />
        <div className={styles.explore_hub_title_description__description_mobile}>
          {descriptionText}
        </div>
      </div>
      <div
        id={POPOVER_ID}
        className={styles.explore_hub_title_description__description}
        popover="auto"
        // @ts-ignore React styles types don't yet have positionAnchor
        style={{ positionAnchor: '--explore-hub-title' }}
      >
        {descriptionText}
        <button
          className={styles.explore_hub_title_description__close_button}
          popoverTarget={POPOVER_ID}
          popoverTargetAction="hide"
          aria-label="Close description"
        >
          <CloseIcon />
        </button>
      </div>
    </div>
  );
}

export default ExploreHubTitleDescription;
